import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Fab,
  TextField,
  Button,
  Grid,
  Paper,
} from "@mui/material";
import BackupOutlinedIcon from "@mui/icons-material/BackupOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import {
  createAttachmentPreAuth,
  deleteAttachmentPreAuth,
  fetchAttachmentsPreAuth,
} from "../../action";
import { decodeId } from "../../utils/helper";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DocumentViewDialog from "../DocumentViewDailog/DocumentView";
import { GedToken } from "../../utils/constant";
import { baseApiUrl } from "../../store/store";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: "1rem",
}));

export const PreAuthDocs = ({ setAttachments, claimData, disabled }) => {

  const AttachmentsData = useSelector(
    (state) => state?.fosaReducer?.AttachmentsData
  );
  const { t } = useTranslation();
  const [fileUploads, setFileUploads] = useState([
    {
      title: "",
      file: null,
      progress: 0,
      filename: "",
      mime: "",
      document: "",
    },
  ]);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const idWithPrefix = pathname.split("/").pop();
  const urlId = idWithPrefix.split("=")[1];

  const [blobUrl, setBlobURL] = useState();

  const [documentView, setDocumentView] = useState(false);

  const handleTitleChange = (event, index) => {
    const newTitle = event.target.value;
    setFileUploads((prev) =>
      prev.map((upload, i) =>
        i === index ? { ...upload, title: newTitle } : upload
      )
    );
  };

  const handleFileChange = (title, event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(",")[1];
        const updatedFileUpload = {
          title,
          file: selectedFile,
          filename: selectedFile.name,
          mime: selectedFile.type,
          document: base64,
          uuid: claimData?.id ? claimData?.id : "",
        };

        setFileUploads((prev) =>
          prev.map((upload) =>
            upload.title === title ? updatedFileUpload : upload
          )
        );

        // If claim.uuid is present, dispatch the async action
        if (claimData?.id) {
          dispatch(createAttachmentPreAuth([updatedFileUpload])); // Sending as array
        }
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  useEffect(() => {

    if (fileUploads) {
      const filesWithDocument = fileUploads.filter((file) => file.document);
      setAttachments(filesWithDocument);
    }
  }, [fileUploads, setAttachments]);

  useEffect(() => {
    if (claimData?.id) {
      dispatch(fetchAttachmentsPreAuth(decodeId(claimData?.id)));
    }
  }, [claimData?.id, dispatch]);

  const handleRemoveFile = (index) => {
    if (fileUploads.length == index + 1) {
      setFileUploads((prev) =>
        prev.map((upload, i) =>
          i === index
            ? {
              ...upload,
              title: "",
              file: null,
              progress: 0,
              filename: "",
              mime: "",
              document: "",
            }
            : upload
        )
      );
    } else {
      setFileUploads((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const handleDeleteCall = (index, id) => {
    let docId;
    if (id) {
      docId = decodeId(id);
    }
    dispatch(deleteAttachmentPreAuth(docId));
    setTimeout(() => {
      dispatch(fetchAttachmentsPreAuth(decodeId(claimData?.id)));
    }, 100);
  };

  const addNewUpload = () => {
    setFileUploads((prev) => [
      ...prev,
      {
        title: "",
        file: null,
        progress: 0,
        filename: "",
        mime: "",
        document: "",
      },
    ]);
  };

  const handleDocumnetView = async (token, id) => {
    return fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/claim/attach/?id=${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const pdfUrl = URL.createObjectURL(blob);
        setBlobURL(pdfUrl);
        setDocumentView(true);
      })
      .catch((error) => {
        console.error("API request error:", error);
      });
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <StyledPaper>
            <StyledPaperHeader container alignItems="center" direction="row">
              <Grid
                container
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography variant="h6">{t("ClaimDocuments")}</Typography>
                {disabled ? null : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={addNewUpload}
                  >
                    {t("Add")}
                  </Button>
                )}
              </Grid>
            </StyledPaperHeader>
            <StyledGrid>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {urlId &&
                  AttachmentsData?.map(
                    ({ id, type, title, date, filename, mime }, index) => (
                      <section
                        key={id}
                        className="drag-drop"
                        style={{ marginRight: "1rem" }}
                      >
                        <TextField
                          label={t("Title")}
                          value={title}
                          fullWidth
                          style={{ marginBottom: ".2rem" }}
                          InputProps={{
                            readOnly: true,
                          }}
                          disabled={disabled}
                        />
                        <div className="file-list">
                          <div className="file-list__container">
                            <Card className="file-item">
                              <CardContent
                                display="flex"
                                sx={{ width: "100%" }}
                                size="large"
                              >
                                <Fab color="disabled">
                                  <DescriptionOutlinedIcon />
                                </Fab>
                                <Typography variant="body1">
                                  {filename}
                                </Typography>
                                <div>
                                  <IconButton aria-label="view document">
                                    <VisibilityIcon
                                      onClick={() =>
                                        handleDocumnetView(
                                          AttachmentsData[index],
                                          decodeId(id)
                                        )
                                      }
                                    />
                                  </IconButton>

                                  {disabled ? null : (
                                    <IconButton
                                      sx={{ float: "right" }}
                                      onClick={() => handleDeleteCall(index, id)}
                                    >
                                      {false ? (
                                        <ClearIcon />
                                      ) : (
                                        <DeleteOutlineOutlinedIcon />
                                      )}
                                    </IconButton>
                                  )}
                                </div>
                              </CardContent>
                            </Card>
                          </div>
                        </div>
                      </section>
                    )
                  )}
                {disabled ? null : fileUploads.map(
                  (
                    { title, file, progress, filename, mime, document },
                    index
                  ) => (
                    <section
                      key={index}
                      className="drag-drop"
                      style={{ marginRight: "1rem" }}
                    >
                      <TextField
                        label={t("Title")}
                        value={title}
                        onChange={(e) => handleTitleChange(e, index)}
                        fullWidth
                        style={{ marginBottom: ".2rem" }}
                      />
                      <div
                        className={`document-uploader ${file ? "upload-box active" : "upload-box"
                          }`}
                        onDrop={(event) => event.preventDefault()}
                        onDragOver={(event) => event.preventDefault()}
                      >
                        <label
                          htmlFor={`browse-${index}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            flexDirection: "column",
                          }}
                        >
                          <div className="upload-info">
                            <BackupOutlinedIcon />
                          </div>
                          <div>
                            <p>
                              <span>
                                <input
                                  type="file"
                                  hidden
                                  id={`browse-${index}`}
                                  onChange={(event) =>
                                    handleFileChange(title, event)
                                  }
                                  accept=".pdf,.docx,.pptx,.txt,.xlsx"
                                  disabled={!title}
                                />
                                <span className={`browse-btn ${!title ? "disabled" : ""}`}>
                                  {t("orChoosefile")}
                                </span>
                              </span>
                            </p>
                          </div>
                        </label>
                      </div>
                      {file && (
                        <div className="file-list">
                          <div className="file-list__container">
                            <Card className="file-item">
                              <CardContent
                                display="flex"
                                sx={{ width: "100%" }}
                                size="large"
                              >
                                <Fab color="disabled">
                                  <DescriptionOutlinedIcon />
                                </Fab>
                                <Typography variant="body1">
                                  {filename ? filename : "No file selected"}
                                </Typography>
                                <IconButton
                                  sx={{ float: "right" }}
                                  onClick={() => handleRemoveFile(index)}
                                >
                                  {false ? (
                                    <ClearIcon />
                                  ) : (
                                    <DeleteOutlineOutlinedIcon />
                                  )}
                                </IconButton>
                              </CardContent>
                            </Card>
                          </div>
                        </div>
                      )}
                      {!file && (
                        <div className="file-list">
                          <div
                            className="file-list__container"
                            style={{ minHeight: "70px" }}
                          ></div>
                        </div>
                      )}
                    </section>
                  )
                )}
              </div>
            </StyledGrid>
          </StyledPaper>
        </Grid>

        {documentView && (
          <DocumentViewDialog
            blobUrl={blobUrl}
            documentView={documentView}
            setDocumentView={setDocumentView}
          />
        )}
      </Grid>
    </div>
  );
};
